
import { mixins, Options } from "vue-class-component";
import {
  RoutingUtilityMixin,
  AlbumAndAssetManagementMixin,
  AssetDescriptionAccessMixin,
} from "@/mixins";
import SvgIcon from "@/components/ui/BaseIcons/SvgIcon.vue";
import { useMq } from "vue3-mq";

@Options({
  name: "LearnMoreButton",
  components: {
    SvgIcon,
  },
})
export default class LearnMoreButtonMobile extends mixins(
  RoutingUtilityMixin,
  AlbumAndAssetManagementMixin,
  AssetDescriptionAccessMixin
) {
  protected mq = useMq();
  private isLearnMoreActive = false;

  protected get isDesktop(): boolean {
    return ["lg", "xl", "xxl"].includes(this.mq.current);
  }

  protected get isDescriptionDisabled(): boolean {
    const slug = this.$route.params.assetSlug as string;
    return this.isDescriptionDisabledForSlug(slug, this.isDesktop);
  }

  protected toggleDescription(): void {
    this.emitter.emit(
      "asset-description-toggle",
      (this.isLearnMoreActive = !this.isLearnMoreActive)
    );
  }

  protected get getReadMoreKey(): string {
    return this.isLearnMoreActive ? "close" : "learn_more";
  }

  protected get learnMoreButtonClasses(): (string | Record<string, boolean>)[] {
    return [
      "btn",
      "btn--learn-more",
      {
        "is-active": this.isLearnMoreActive,
        "is-disabled": this.isDescriptionDisabled,
      },
    ];
  }

  mounted(): void {
    this.emitter.on("asset-description-toggle", (state: boolean): void => {
      this.isLearnMoreActive = state;
    });
  }
}
